import React, { useState } from "react";
import ConfigETC from "../Class/ConfigETC.json";

import BootstrapSwitchButton from 'bootstrap-switch-button-react'
function DepartmentEdittableRow({ listedit, index, Onclick_SaveEditDepartment, Onclick_CancelDepartment }) {
  const [isDepartmentStatusEdit, setIsDepartmentStatusEdit] = useState(listedit.Department_status === 1 ? true : false); 

  return (

    <tr className="card-footer">
      <td style={{ width: "5%" }}>
        {index}<input type="hidden" id="hd_idedit" defaultValue={listedit.Department_id}></input>
      </td>
      <td style={{ width: "30%" }}>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="Name"
          id="txt_Department_Name_Edit"
          defaultValue={listedit.Department_name}
        />
      </td>
      <td style={{ width: "30%" }}>
        <textarea
          className="form-control"
          rows={2}
          placeholder="Description ..."
          id="txt_Department_Desc_Edit"
          defaultValue={listedit.Department_desc}
        />
      </td>
      <td style={{ width: "10%" }} className="text-center">
        <div>
          <BootstrapSwitchButton
            onChange={(checked) => { setIsDepartmentStatusEdit(checked) }}
            checked={(isDepartmentStatusEdit)}
            width={ConfigETC.SwitchButton_in_active_width} 
            onlabel={ConfigETC.SwitchButton_active_text}
            onstyle={ConfigETC.SwitchButton_active_color}
            offlabel={ConfigETC.SwitchButton_inactive_text}
            offstyle={ConfigETC.SwitchButton_inactive_color}
            size="xs"
          />
        <input type="hidden" id="hd_status_edit" defaultValue={isDepartmentStatusEdit}></input>
        </div>
      </td>
      <td style={{width: '15%'}} className="text-center">
      </td>
      <td style={{ width: "10%" }} className="text-right  align-top">
          <div className="btn-group btn-group-sm">
            <a
              href="#!"
              className="btn btn-primary btn-sm"
              onClick={() => Onclick_SaveEditDepartment(isDepartmentStatusEdit)}
            > <i className="fas fa-save" />
            </a>
            <a
              href="#!" className="btn btn-default btn-sm"
              onClick={() => Onclick_CancelDepartment()}
            > <i className="fas fa-times fa-lg" />
            </a>
          </div>
      </td>
    </tr>
  );
};

export default DepartmentEdittableRow;